<template>

	<tr v-if="orderState.marketFillable" class="pa-3 simple-order-summary-row">

		<td v-if="showtokens" class="text-nowrap">
			<ERC20Token class="d-inline-block" :symbol="parsedOrder.metaData.makerAsset.symbol"
				:name="parsedOrder.metaData.makerAsset.name"
				:address="parsedOrder.makerAssetAddress"
				:decimals="parsedOrder.metaData.makerAsset.decimals"
				:tokenurl="tokenurl" ></ERC20Token>
			<ERC20Token class="d-inline-block" :symbol="parsedOrder.metaData.takerAsset.symbol"
				:name="parsedOrder.metaData.takerAsset.name"
				:address="parsedOrder.takerAssetAddress"
				:decimals="parsedOrder.metaData.takerAsset.decimals"
				:tokenurl="tokenurl" ></ERC20Token>
		</td>

		<!-- Begin Amount -->
		<td v-show="!reversedisplay && showmakeramount" class="text-right">
			<span class="order-table-number"><AmountNumber :value="parsedOrder.makerAssetAmount" digits="7" keepzeros /></span>
		</td>

		<td v-show="!reversedisplay && showavailablemakeramount" class="text-right">
			<span class="order-table-number"><AmountNumber :value="orderState.availableMakerAmount" digits="7" keepzeros /></span>
		</td>

		<td v-show="showtakeramount" class="text-right">
			<span class="order-table-number"><AmountNumber :value="parsedOrder.takerAssetAmount" digits="7" keepzeros /></span>
		</td>

		<td v-show="showavailabletakeramount" class="text-right">
			<span class="order-table-number"><AmountNumber :value="orderState.availableTakerAmount" digits="7" keepzeros /></span>
		</td>

		<td v-show="reversedisplay && showmakeramount" class="text-right">
			<span class="order-table-number"><AmountNumber :value="parsedOrder.makerAssetAmount" digits="7" keepzeros /></span>
		</td>

		<td v-show="reversedisplay && showavailablemakeramount" class="text-right">
			<span class="order-table-number"><AmountNumber :value="orderState.availableMakerAmount" digits="7" keepzeros /></span>
		</td>
		<!-- End Amount -->

		<!-- Begin Price -->
		<td v-show="!reversedisplay && showpricetakerpermaker" class="text-right">
				<span class="order-table-number"><AmountNumber :value="parsedOrder.priceTakerPerMaker" digits="7" keepzeros /></span>
		</td>

		<td v-show="showpricemakerpertaker" class="text-right">
				<span class="order-table-number"><AmountNumber :value="parsedOrder.priceMakerPerTaker" digits="7" keepzeros /></span>
		</td>

		<td v-show="reversedisplay && showpricetakerpermaker" class="text-right">
				<span class="order-table-number"><AmountNumber :value="parsedOrder.priceTakerPerMaker" digits="7" keepzeros /></span>
		</td>
		<!-- End Price -->

		<td v-if="showrelayer" class="text-right">
			 <small>{{ shortRelayerName }}</small>
		</td>

		<td class="text-right">
			<div v-if="isMyOwnOrder">
				<v-btn class="fill-order-button my-1" color="primary" depressed small disabled >{{ $t('compSimpleOrderSummary.yourOrder') }}</v-btn>
			</div>
			<div v-else>
				<v-btn class="fill-order-button my-1" color="primary" depressed small @click="handleFillOrderClick()">{{ $t('compSimpleOrderSummary.btnFillOrder', { tokenSymbol: parsedOrder.metaData.takerAsset.symbol }) }}</v-btn>
			</div>
		</td>

	</tr>


</template>

<script>
import { config } from '@/config'
import { mapActions, mapGetters, mapState } from 'vuex'
import UserAddress from "@/components/UserAddress"
import AmountNumber from "@/components/AmountNumber"
import PendingTransaction from "@/components/PendingTransaction"
import ERC20Token from "@/components/ERC20Token"
import { showDateTime, loadOrderState, countDecimals, getCurrentUnixTime } from '@/utils/utils'
import { NULL_ADDRESS, ZERO } from '@/config/constants'

export default {
	name: 'SimpleOrderSummary',
	components: {
		UserAddress,
		AmountNumber,
		ERC20Token,
		PendingTransaction
	},
	props: {
		parsedOrder: { type: Object, required: true },
		myaddress: { type: String, required: true },
		myaccount: { type: Object, required: true },
		accounturl: { type: String },
		txurl: { type: String },
		tokenurl: { type: String },
		initialorderstatechecking: { type: Boolean, default: false },
		continuousorderstatechecking: { type: Boolean, default: false },
		ordercheckingtimeinterval: { type: Number, default: config.autoOrderStateCheckingTimeInterval },
		relayer: { type: Object },
		reversedisplay: { type: Boolean, default: false },
		showtokens: { type: Boolean, default: false },
		showrelayer: { type: Boolean, default: false },
		showmakeramount: { type: Boolean, default: false },
		showavailablemakeramount: { type: Boolean, default: false },
		showtakeramount: { type: Boolean, default: false },
		showavailabletakeramount: { type: Boolean, default: false },
		showpricetakerpermaker: { type: Boolean, default: false },
		showpricemakerpertaker: { type: Boolean, default: false },
	},
	data () {
		return {
			config: config,
			orderState: {},
			orderStateLoading: false,
			initialOrderStateLoadingDone: false,
			loopJob: null
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			myAddress: 'getUserAccount',
			networkConfig: 'getNetworkConfig',
			web3Wrapper: 'getWeb3Wrapper',
			providerEngine: 'getProviderEngine',
			contractWrappers: 'getContractWrappers',
			contractAddresses: 'getContractAddresses',
		}),
		shortRelayerName: function () {
			if (!this.relayer) {
				return ''
			}
			return this.relayer.name.replace(/ .*/,'')
		},
		isMyOwnOrder: function () {
			return this.parsedOrder.makerAddress && this.parsedOrder.makerAddress === this.network.userAccount
		},
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount', 'updateAccountForToken']),
		showDateTime: showDateTime,
		async init() {
			// console.log(this.parsedOrder)
			this.orderState = {
				marketFillable: true,
				availableMakerAmount: this.parsedOrder.makerAssetAmount,
				availableTakerAmount: this.parsedOrder.takerAssetAmount
			}
			this.orderStateLoading = false
			this.initialOrderStateLoadingDone = false
			this.loopJob = null
			if (this.initialorderstatechecking || this.continuousorderstatechecking) {
				await this.updateAssetBalance()
				await this.checkOrderState()
			}
			if (this.continuousorderstatechecking) {
				this.loopJob = setInterval(this.checkOrderState, this.ordercheckingtimeinterval)
			}
			else {
				// If order will expire soon (within 1 hour), set up interval to check state
				const timeNow = getCurrentUnixTime()
				const expirationTime = this.parsedOrder.expirationTimeSeconds
				const timeDiff = expirationTime - timeNow
				// console.log(expirationTime, timeNow, timeDiff)
				if (timeDiff < 0) {
					this.$emit('simple-order-summary-order-not-fillable', this.parsedOrder.orderHash)
					clearInterval(this.loopJob)
				}
				if (timeDiff > 0 && timeDiff < 60 * 60) {
					// console.log('Will check expiration automatically in ' + timeDiff)
					const checkExpirationInterval = (timeDiff + 1) * 1000
					this.loopJob = setInterval(this.checkOrderState, checkExpirationInterval)
				}
			}
		},
		handleFillOrderClick () {
			this.$emit('simple-order-summary-show-fill-order', this.parsedOrder)
		},
		async updateAssetBalance () {
			const makerAsseetBalance = this.account.balanceByAddress[this.parsedOrder.makerAssetAddress]
			const makerAsseetAllowance = this.account.allowanceByAddress[this.parsedOrder.makerAssetAddress]
			// console.log('makerAsseetBalance', makerAsseetBalance)
			// console.log('makerAsseetAllowance', makerAsseetAllowance)
			if (makerAsseetBalance === undefined || makerAsseetBalance === null || makerAsseetAllowance === undefined || makerAsseetAllowance === null) {
				await this.updateAccountForToken(this.parsedOrder.metaData.makerAsset)
			}

			const takerAsseetBalance = this.account.balanceByAddress[this.parsedOrder.takerAssetAddress]
			const takerAsseetAllowance = this.account.allowanceByAddress[this.parsedOrder.takerAssetAddress]
			// console.log('takerAsseetBalance', takerAsseetBalance)
			// console.log('takerAsseetAllowance', takerAsseetAllowance)
			if (takerAsseetBalance === undefined || takerAsseetBalance === null || takerAsseetAllowance === undefined || takerAsseetAllowance === null) {
				await this.updateAccountForToken(this.parsedOrder.metaData.takerAsset)
			}
		},
		async checkOrderState () {
			// console.log('checkOrderState')
			// console.log('checkOrderState: ' + this.parsedOrder.orderHash)
			if (this.orderStateLoading) {
				return
			}
			this.orderStateLoading = true

			// Check Expiration Time to save API calls
			const timeNow = getCurrentUnixTime()
			const expirationTime = this.parsedOrder.expirationTimeSeconds
			const timeDiff = expirationTime - timeNow
			// console.log(expirationTime, timeNow, timeDiff)
			if (timeDiff < 0) {
				this.$emit('simple-order-summary-order-not-fillable', this.parsedOrder.orderHash)
				clearInterval(this.loopJob)
				this.initialOrderStateLoadingDone = true
				this.orderStateLoading = false
				return
			}

			const orderState = await loadOrderState(
				this.parsedOrder.signedOrder,
				this.parsedOrder.metaData,
				this.myaddress,
				this.myaccount,
				this.contractWrappers
			)

			this.orderState = { ...orderState }
			// console.log(orderState.availableTakerAmount)

			if (orderState.marketFillable === false || orderState.availableTakerAmount < config.minOrderAvailableAmount) {
				this.$emit('simple-order-summary-order-not-fillable', this.parsedOrder.orderHash)
				clearInterval(this.loopJob)
			}

			this.initialOrderStateLoadingDone = true
			this.orderStateLoading = false
		},
		stopLoopJob () {
			// console.log('####### Stopping Loop #########')
			clearInterval(this.loopJob)
		}
	},
	created () {
		this.init()
	},
	beforeDestroy () {
		// console.log('SimpleOrderSummary beforeDestroy')
		this.stopLoopJob()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.order-section {
	margin: 10px auto;
	padding: 20px 25px 20px 25px;
	border: 1px solid #dedede;
	min-width: 500px;
	max-width: 600px;
	background-color: #f9f9f9;
	/*background-color: #FFF;*/
}
.order-amount-wrapper {
	display: inline-block;
	background-color: #FFF;
	padding: 3px 8px;
	border-top: 1px solid #CCC;
	border-right: 1px solid #CCC;
	border-bottom: 1px solid #CCC;
	margin-left: -8px;
}
.order-price-wrapper {
	display: inline-block;
	background-color: #FFF;
	padding: 0px 8px;
	border: 1px solid #CCC;
}
.simple-order-summary-row {

}
.fill-order-button {
	margin-top: 2px;
	margin-bottom: 2px;
	/*padding: 1px 5px !important;*/
}
.v-data-table td, .v-data-table th {
	padding: 0 6px !important;
}
</style>
